let accessToken = '';

const set = (s: string) => {
  accessToken = s;
};

const get = (): string => accessToken;

const hasToken = (): boolean => !!accessToken;

export default {
  set,
  get,
  hasToken,
};
